export const AUTOFILL_TYPES = [
  'name',
  'given_name',
  'family_name',
  'title',
  'company_size',
  'company_domain',
  'company_name',
  'country_code',
];

export const HIDDEN_TYPES = ['cookie', 'param', 'hidden'];

export const NO_PLACEHOLDER_TYPES = [...HIDDEN_TYPES, 'checkbox', 'select'];

export const LABEL_FOR_FIELD_TYPE = {
  email: 'Email',
  given_name: 'Given name',
  family_name: 'Family name',
  name: 'Full name',
  title: 'Job title',
  phone: 'Phone',
  company_size: 'Company size',
  company_domain: 'Company domain',
  company_name: 'Company name',
  country_code: 'Country',
  text: 'Short Text',
  textarea: 'Long Text',
  checkbox: 'Checkbox',
  select: 'Dropdown',
  cookie: 'Cookie value',
  param: 'URL param value',
  hidden: 'Hidden value',
};

// matches markdown links like [click here!](google.com),
// capturing the title 'click here!' and the href 'google.com'
// as match groups
const MD_LINK_REGEX = /\[([^\]]*?)\]\((.*?)\)/g;

export const replaceLinks = (description) => {
  if (!description) return;

  let index = 0;
  let parts = [];
  let match;

  while ((match = MD_LINK_REGEX.exec(description)) !== null) {
    parts.push(
      // span for text up to link
      React.createElement(
        'span',
        { key: `span-${index}` },
        description.slice(index, match.index),
      ),

      // link for regex match
      React.createElement(
        'a',
        {
          href: match[2],
          target: '_blank',
          key: `a-${index}`,
        },
        match[1],
      ),
    );

    // move to end of match for next part
    index = match.index + match[0].length;
  }

  parts.push(
    React.createElement(
      'span',
      { key: `span-${index}` },
      description.slice(index),
    ),
  );

  return parts;
};
